import React from 'react'
import "./SkillCardStyle.css";

// الأيقونات الصحيحة من المكتبات الأصلية
import { DiGit, DiPython } from "react-icons/di";
import { SiVisualstudiocode, SiReact, SiReactrouter, SiBootstrap, SiFigma, SiInkscape, SiMysql, SiFlask, SiXcode, SiSwift, SiJupyter, SiTensorflow } from "react-icons/si";
import { TbBrandCss3, TbBrandJavascript, TbBrandHtml5 } from "react-icons/tb";
import { IoLogoWindows, IoLogoNpm } from "react-icons/io";

export default function SkillCard({ id }) {
  return (
    <>
      <div className="skill-container" id={id}>
        <div className="skill-header">My Skills</div>

        <div className="skill-box">
          <h2>Languages</h2>
          <div className="skillset">
            <abbr title='Python'><DiPython className='techLogo' /></abbr>
            <abbr title='HTML'><TbBrandHtml5 className='techLogo' /></abbr>
            <abbr title='CSS'><TbBrandCss3 className='techLogo' /></abbr>
            <abbr title='JavaScript'><TbBrandJavascript className='techLogo' /></abbr>
            <abbr title='Swift'><SiSwift className='techLogo' /></abbr>
          </div>
        </div>

        <div className="skill-box">
          <h2>Frameworks & Libraries</h2>
          <div className="skillset">
            <abbr title='Flask'><SiFlask className='techLogo' /></abbr>
            <abbr title='ReactJS'><SiReact className='techLogo' /></abbr>
            <abbr title='React Router'><SiReactrouter className='techLogo' /></abbr>
            <abbr title='Bootstrap'><SiBootstrap className='techLogo' /></abbr>
            <abbr title='TensorFlow'><SiTensorflow className='techLogo' /></abbr>
          </div>
        </div>

        <div className="skill-box">
          <h2>Tools & Systems</h2>
          <div className="skillset">
            <abbr title='Git / GitHub'><DiGit className='techLogo' /></abbr>
            <abbr title='VS Code'><SiVisualstudiocode className='techLogo' /></abbr>
            <abbr title='Xcode'><SiXcode className='techLogo' /></abbr>
            <abbr title='Windows'><IoLogoWindows className='techLogo' /></abbr>
            <abbr title='Figma'><SiFigma className='techLogo' /></abbr>
            <abbr title='Inkscape'><SiInkscape className='techLogo' /></abbr>
            <abbr title='Jupyter Notebook'><SiJupyter className='techLogo' /></abbr>
            <abbr title='MySQL'><SiMysql className='techLogo' /></abbr>
            <abbr title='NPM'><IoLogoNpm className='techLogo' /></abbr>
          </div>
        </div>
      </div>
    </>
  )
}
